module.exports = __webpack_public_path__ + "static/N2N3-9288bacbf4f00b6c6b361be9c31e93ba.jpg";